// extracted by mini-css-extract-plugin
module.exports = {"FullPage":"_2X3lXUg3Rz_UdFE480WlI4","AddPost":"_2_137xD4f-LQNoaHHAYr7A","inputFile":"_2uN6-D3rw_fi2TWdOHImuQ"};